// extracted by mini-css-extract-plugin
export default {"content_dt":"Buscas_content_dt__32VhE","content_dtfilmes":"Buscas_content_dtfilmes__6St+V","wrapper":"Buscas_wrapper__W13nP"};